import {makeAutoObservable} from "mobx";
import {equals} from "../../utils";
import {AddressDto, WarehouseDataDto} from "../../api/sls";
import {validationStore} from "../ValidationStore";
import {api, catchApi} from "../../api";
import {SlsWarehouseAddressFormData} from "../../components/page/sls/SlsWarehouseAddressForm";

const emptyObject: WarehouseDataDto = {
    name: '',
    warehouseNumber: '',
    internalAddresses: []
}

class SlsWarehouseCreateStore {

    get addresses(): SlsWarehouseAddressFormData[] {
        return this._addresses;
    }

    set addresses(value: SlsWarehouseAddressFormData[]) {
        this._addresses = value;
    }
    get warehouseNumber(): string | undefined {
        return this._warehouseNumber;
    }

    set warehouseNumber(value: string | undefined) {
        this._warehouseNumber = value;
    }
    get name(): string | undefined {
        return this._name;
    }

    set name(value: string | undefined) {
        this._name = value;
    }
    get valid(): boolean {
        return this._valid;
    }

    private set valid(value: boolean) {
        this._valid = value;
    }

    get creating(): boolean {
        return this._creating;
    }

    private set creating(value: boolean) {
        this._creating = value;
    }

    get dirty(): boolean {
        const current = this.build()
        return !equals(emptyObject, current)
    }

    private _name: string | undefined
    private _warehouseNumber: string | undefined
    private _addresses: SlsWarehouseAddressFormData[] = []
    private _creating: boolean = false
    private _valid: boolean = false

    constructor() {
        makeAutoObservable(this)
    }

    deleteAddress(position: number){
        const toDelete = [...this.addresses]
        toDelete.splice(position,1)
        this.addresses = toDelete
        this.validate()
    }

    reset() {
        this.warehouseNumber = undefined
        this.name = undefined
        this.addresses = []
    }

    async create(): Promise<string | undefined> {
        this.creating = true
        const dto = this.build()
        const result = await catchApi(async () => await api.sls.api.createWarehouse(dto))
        this.creating = false
        return result?.data?.id
    }

    async validate() {
        this.valid = false
        const dto = this.build()

        await validationStore.validateWithQuery(api.sls.api.validateWarehouse, dto, {validateWarehouseNumber: true})
        this.valid = Boolean(validationStore.valid)
    }

    private build(): WarehouseDataDto {
        return {
            name: this.name || '',
            warehouseNumber: this.warehouseNumber || '',
            internalAddresses: this.addresses.map(a => this.toAddressDto(a))
        }
    }

    private toAddressDto(address: SlsWarehouseAddressFormData): AddressDto {
        return {
            city: address.city,
            country: address.country,
            houseNumber: address.houseNumber || undefined,
            postCode: address.postCode,
            street: address.street
        }
    }
}

const slsWarehouseCreateStore = new SlsWarehouseCreateStore()

export {
    slsWarehouseCreateStore
}
